import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HrBulkUpdateTermsPayload } from 'api/actions/hr-bulk-update-terms/hr-bulk-update-terms-payload';
import { HrBulkUpdateTermsPathParameters } from 'api/actions/hr-bulk-update-terms/hr-bulk-update-terms-path-parameters';
import { HrBulkUpdateTermsResponse } from 'api/actions/hr-bulk-update-terms/hr-bulk-update-terms-response';

type HrBulkUpdateTermsQueryParameters = Record<string, any>;

/**
 * The path of the HrBulkUpdateTerms action.
 */
export const hrBulkUpdateTermsActionPath = new SweetPath<keyof HrBulkUpdateTermsPathParameters>('/api/hr/terms/bulk', {
  path: '{param}',
});

/**
 * Creates a contextualized HrBulkUpdateTerms actions.
 */
export default function createHrBulkUpdateTermsAction(axios: AxiosInstance) {
  return function hrBulkUpdateTermsAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: HrBulkUpdateTermsQueryParameters;
    payload: HrBulkUpdateTermsPayload;
  }) {
    const path = hrBulkUpdateTermsActionPath.original;

    return axios.request<HrBulkUpdateTermsResponse, HrBulkUpdateTermsResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
